/* EVORA THEME — interacciones */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- dinero ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || (window.theme && theme.moneyFormat) || '${{amount_no_decimals_with_comma_separator}}';
    function fmt(n, dec, th, dc) {
      dec = dec == null ? 2 : dec; th = th || ','; dc = dc || '.';
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(dec);
      var p = n.split('.');
      var d = p[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
      return d + (p[1] ? dc + p[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var v;
    switch (key) {
      case 'amount': v = fmt(cents, 2); break;
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = fmt(cents, 0, ' '); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  window.EvoraMoney = formatMoney;

  /* ---------- carrito ---------- */
  var drawer = $('#CartDrawer');
  function openDrawer() { if (!drawer) return; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = el.classList.contains('cart-count') ? cart.item_count : '(' + cart.item_count + ')'; el.setAttribute('data-count', cart.item_count); });
    if (!drawer) return;
    var box = $('[data-cart-items]', drawer);
    if (!cart.items.length) {
      box.innerHTML = '<div class="drawer__empty"><p>' + esc(theme.strings.cartEmpty) + '</p><button type="button" class="btn btn--primary" data-cart-close>Seguir comprando</button></div>';
    } else {
      box.innerHTML = cart.items.map(function (it, i) {
        var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="' + esc(it.product_title) + '" loading="lazy">' : '';
        var variant = it.product_has_only_default_variant ? '' : '<div class="ci__var">' + esc(it.variant_title) + '</div>';
        var was = it.original_line_price > it.final_line_price ? '<s>' + formatMoney(it.original_line_price) + '</s>' : '';
        return '<div class="ci" data-line="' + (i + 1) + '">' +
          '<a class="ci__img" href="' + it.url + '">' + img + '</a>' +
          '<div class="ci__info"><a class="ci__title" href="' + it.url + '">' + esc(it.product_title) + '</a>' + variant +
          '<div class="ci__row"><div class="qty"><button type="button" data-qty-minus aria-label="Menos">−</button><input type="number" min="0" value="' + it.quantity + '" data-line-qty><button type="button" data-qty-plus aria-label="Más">+</button></div>' +
          '<div class="ci__price">' + was + formatMoney(it.final_line_price) + '</div></div>' +
          '<button type="button" class="ci__rm" data-line-remove>' + esc(theme.strings.remove) + '</button></div></div>';
      }).join('');
    }
    var sub = $('[data-cart-subtotal]', drawer);
    if (sub) sub.textContent = formatMoney(cart.total_price);
    var fs = $('[data-fship]', drawer);
    if (fs && theme.freeShipping > 0) {
      var left = theme.freeShipping - cart.total_price;
      var pct = Math.min(100, Math.round(cart.total_price / theme.freeShipping * 100));
      $('[data-fship-bar]', fs).style.width = pct + '%';
      $('[data-fship-text]', fs).innerHTML = left > 0 ? theme.strings.freeShipLeft.replace('[monto]', '<strong>' + formatMoney(left) + '</strong>') : theme.strings.freeShipDone;
    }
  }
  function fetchCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; }); }
  function changeLine(line, qty) {
    return fetch(theme.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  }
  function addToCart(items) {
    return fetch(theme.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  window.EvoraCart = { open: openDrawer, close: closeDrawer, refresh: fetchCart, add: addToCart };

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }
    if (t.closest('[data-cart-open]')) { e.preventDefault(); fetchCart().then(openDrawer); return; }
    var line = t.closest('[data-line]');
    if (line) {
      var n = +line.getAttribute('data-line');
      var inp = $('[data-line-qty]', line);
      if (t.closest('[data-qty-minus]')) changeLine(n, Math.max(0, +inp.value - 1));
      if (t.closest('[data-qty-plus]')) changeLine(n, +inp.value + 1);
      if (t.closest('[data-line-remove]')) changeLine(n, 0);
    }
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-line-qty]');
    if (inp) changeLine(+inp.closest('[data-line]').getAttribute('data-line'), Math.max(0, +inp.value));
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closeNav(); closePop(); } });

  /* ---------- formularios de producto ---------- */
  function initProductForm(form) {
    var btns = $$('[data-atc]', form);
    var priceEls = $$('[data-atc-price]', document);
    var packs = $$('[data-pack]', form);
    var idInput = $('input[name="id"][type="hidden"]', form);
    var qtyInput = $('[data-qty-input]', form);

    function current() {
      var active = packs.filter(function (p) { return $('input', p).checked; })[0];
      if (active) return { id: active.getAttribute('data-variant'), qty: +active.getAttribute('data-qty') || 1, price: +active.getAttribute('data-price'), compare: +active.getAttribute('data-compare'), el: active };
      var sel = $('select[name="id"]', form);
      var opt = sel ? sel.options[sel.selectedIndex] : null;
      return { id: opt ? opt.value : (idInput && idInput.value), qty: qtyInput ? +qtyInput.value || 1 : 1, price: opt ? +opt.getAttribute('data-price') : null };
    }
    function refreshPrice() {
      var c = current();
      packs.forEach(function (p) { p.classList.toggle('is-active', $('input', p).checked); });
      if (c.price == null || isNaN(c.price)) return;
      var total = formatMoney(c.price);
      function mine(el) { var f = el.closest('form'); return f ? f === form : (form.id === 'ProductForm-main' && el.hasAttribute('data-global')); }
      priceEls.forEach(function (el) { if (mine(el)) el.textContent = total; });
      $$('[data-atc-compare]').forEach(function (el) { if (mine(el)) el.textContent = c.compare > c.price ? formatMoney(c.compare) : ''; });
    }
    packs.forEach(function (p) { $('input', p).addEventListener('change', refreshPrice); });
    var sel = $('select[name="id"]', form);
    if (sel) sel.addEventListener('change', refreshPrice);
    $$('[data-qty-step]', form).forEach(function (b) {
      b.addEventListener('click', function () { qtyInput.value = Math.max(1, (+qtyInput.value || 1) + (+b.getAttribute('data-qty-step'))); });
    });
    refreshPrice();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var c = current();
      if (!c.id) return;
      btns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
      var items = [{ id: +c.id, quantity: c.qty }];
      var gift = form.getAttribute('data-gift');
      if (gift && c.el && c.el.hasAttribute('data-with-gift')) items.push({ id: +gift, quantity: 1 });
      addToCart(items).then(function () {
        if (form.getAttribute('data-redirect') === 'checkout') { window.location.href = '/checkout'; return; }
        if (form.getAttribute('data-redirect') === 'cart') { window.location.href = theme.routes.cart; return; }
        return fetchCart().then(openDrawer);
      }).catch(function (err) {
        alert((err && (err.description || err.message)) || 'No se pudo agregar al carrito');
      }).then(function () { btns.forEach(function (b) { b.removeAttribute('aria-busy'); b.disabled = false; }); });
    });
  }

  /* botones "comprar" externos: data-submit-form="ID" o data-add-variant */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-submit-form]');
    if (b) {
      var f = document.getElementById(b.getAttribute('data-submit-form'));
      if (f) { e.preventDefault(); if (f.requestSubmit) f.requestSubmit(); else f.dispatchEvent(new Event('submit', { cancelable: true })); }
      return;
    }
    var a = e.target.closest('[data-add-variant]');
    if (a) {
      e.preventDefault();
      addToCart([{ id: +a.getAttribute('data-add-variant'), quantity: +(a.getAttribute('data-add-qty') || 1) }]).then(function () {
        if (a.getAttribute('data-redirect') === 'checkout') { location.href = '/checkout'; return; }
        return fetchCart().then(openDrawer);
      }).catch(function (err) { alert((err && err.description) || 'No se pudo agregar'); });
    }
    var sc = e.target.closest('[data-scroll-to]');
    if (sc) {
      var tgt = document.querySelector(sc.getAttribute('data-scroll-to'));
      if (tgt) { e.preventDefault(); tgt.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    }
  });

  function initAll(root) {
  root = root || document;
  $$('form[data-product-form]', root).forEach(initProductForm);
  /* ---------- galería ---------- */
  $$('[data-gallery]', root).forEach(function (g) {
    var track = $('.gal__track', g);
    var thumbs = $$('.gal__thumb', g);
    var slides = $$('.gal__slide', g);
    function idx() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) { i = (i + slides.length) % slides.length; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    var prev = $('.gal__arrow--prev', g), next = $('.gal__arrow--next', g);
    if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
    if (next) next.addEventListener('click', function () { go(idx() + 1); });
    track.addEventListener('scroll', function () {
      var i = idx();
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', i === j); });
      var at = thumbs[i]; if (at && at.parentNode.scrollTo) at.parentNode.scrollTo({ left: at.offsetLeft - 40, behavior: 'smooth' });
    }, { passive: true });
  });

  /* ---------- sliders ---------- */
  $$('[data-slider]', root).forEach(function (s) {
    var track = $('.slider__track', s);
    if (!track) return;
    var slides = $$('.slider__slide', track);
    var dotsBox = $('.slider__dots', s);
    function step() { return slides[0] ? slides[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 14) : track.clientWidth; }
    function cur() { return Math.round(track.scrollLeft / step()); }
    if (dotsBox) {
      dotsBox.innerHTML = slides.map(function (_, i) { return '<button type="button" class="slider__dot" aria-label="Ir a ' + (i + 1) + '"></button>'; }).join('');
      $$('.slider__dot', dotsBox).forEach(function (d, i) { d.addEventListener('click', function () { track.scrollTo({ left: i * step(), behavior: 'smooth' }); }); });
    }
    function upd() { var i = cur(); $$('.slider__dot', s).forEach(function (d, j) { d.classList.toggle('is-active', i === j); }); }
    track.addEventListener('scroll', upd, { passive: true }); upd();
    var p = $('[data-prev]', s), n = $('[data-next]', s);
    if (p) p.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (n) n.addEventListener('click', function () {
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    var auto = +s.getAttribute('data-autoplay');
    if (auto > 0) {
      var timer = setInterval(function () { if (!document.hidden && n) n.click(); }, auto * 1000);
      track.addEventListener('pointerdown', function () { clearInterval(timer); }, { once: true });
    }
  });

  /* ---------- anuncio rotativo ---------- */
  $$('[data-rotate]', root).forEach(function (box) {
    var items = $$('.ann__item', box);
    if (items.length < 2) { if (items[0]) items[0].classList.add('is-active'); return; }
    var i = 0; items[0].classList.add('is-active');
    setInterval(function () { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, (+box.getAttribute('data-rotate') || 4) * 1000);
  });

  /* ---------- cuenta regresiva ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  $$('[data-countdown]', root).forEach(function (el) {
    var mode = el.getAttribute('data-mode');
    var end;
    if (mode === 'date' && el.getAttribute('data-end')) end = new Date(el.getAttribute('data-end')).getTime();
    else if (mode === 'midnight') { var d = new Date(); d.setHours(24, 0, 0, 0); end = d.getTime(); }
    else {
      var mins = +el.getAttribute('data-minutes') || 15;
      var key = 'evora_cd_' + (el.getAttribute('data-key') || 'x');
      try { end = +localStorage.getItem(key); } catch (e) { end = 0; }
      if (!end || end < Date.now()) { end = Date.now() + mins * 60000; try { localStorage.setItem(key, end); } catch (e) {} }
    }
    var dd = $('[data-d]', el), hh = $('[data-h]', el), mm = $('[data-m]', el), ss = $('[data-s]', el);
    function tick() {
      var diff = Math.max(0, end - Date.now());
      if (diff === 0 && mode !== 'date') {
        if (mode === 'midnight') { var d2 = new Date(); d2.setHours(24, 0, 0, 0); end = d2.getTime(); }
        else { end = Date.now() + (+el.getAttribute('data-minutes') || 15) * 60000; }
      }
      var s = Math.floor(diff / 1000);
      var days = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      if (dd) { dd.textContent = pad(days); } else { h += days * 24; }
      if (hh) hh.textContent = pad(h); if (mm) mm.textContent = pad(m); if (ss) ss.textContent = pad(sec);
    }
    tick(); setInterval(tick, 1000);
  });

  /* ---------- fecha de entrega ---------- */
  var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  var MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; } return d; }
  $$('[data-delivery]', root).forEach(function (el) {
    var min = +el.getAttribute('data-min') || 1, max = +el.getAttribute('data-max') || 2;
    var a = addBiz(new Date(), min), b = addBiz(new Date(), max);
    var f = function (d) { return DIAS[d.getDay()] + ' ' + d.getDate() + ' de ' + MESES[d.getMonth()]; };
    var fShort = function (d) { return DIAS[d.getDay()] + ' ' + d.getDate(); };
    el.textContent = min === max ? f(a) : ((a.getMonth() === b.getMonth() ? fShort(a) : f(a)) + ' o el ' + f(b));
  });
  $$('[data-today]', root).forEach(function (el) { var d = new Date(); el.textContent = d.getDate() + ' de ' + MESES[d.getMonth()] + ' de ' + d.getFullYear(); });

  /* ---------- sticky add to cart ---------- */
  $$('[data-sticky-atc]', root).forEach(function (bar) {
    var target = document.querySelector(bar.getAttribute('data-watch') || '[data-main-atc]');
    if (!target || !('IntersectionObserver' in window)) { bar.classList.add('is-visible'); return; }
    var footer = document.querySelector('.ftr');
    var past = false;
    new IntersectionObserver(function (en) {
      en.forEach(function (x) { past = !x.isIntersecting && x.boundingClientRect.top < 0; bar.classList.toggle('is-visible', past); });
    }).observe(target);
    if (footer) new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) bar.classList.remove('is-visible'); else if (past) bar.classList.add('is-visible'); }); }).observe(footer);
  });
  $$('[data-show-after-scroll]', root).forEach(function (bar) {
    var px = +bar.getAttribute('data-show-after-scroll') || 600;
    window.addEventListener('scroll', function () { bar.classList.toggle('is-visible', window.scrollY > px); }, { passive: true });
  });

  /* ---------- contadores animados ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (!x.isIntersecting) return;
        io.unobserve(x.target);
        var el = x.target, to = parseFloat(el.getAttribute('data-count-to')) || 0, dec = (String(to).split('.')[1] || '').length, t0 = null, dur = 1600;
        var sep = el.getAttribute('data-sep') || '.';
        function fr(t) {
          if (!t0) t0 = t; var p = Math.min(1, (t - t0) / dur); var v = to * (1 - Math.pow(1 - p, 3));
          var s = v.toFixed(dec); var parts = s.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
          el.textContent = parts.join(','); if (p < 1) requestAnimationFrame(fr);
        }
        requestAnimationFrame(fr);
      });
    }, { threshold: .4 });
    $$('[data-count-to]', root).forEach(function (el) { io.observe(el); });
  }
  }
  initAll(document);

  /* ---------- menú móvil ---------- */
  var nav = $('#MobileNav');
  function closeNav() { if (nav) nav.classList.remove('is-open'); }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-nav-open]') && nav) { nav.classList.add('is-open'); }
    if (e.target.closest('[data-nav-close]')) closeNav();
  });

  /* ---------- popup ---------- */
  var pop = $('[data-popup]');
  function closePop() { if (pop) { pop.classList.remove('is-open'); try { localStorage.setItem('evora_pop', Date.now()); } catch (e) {} } }
  if (pop) {
    var seen = 0; try { seen = +localStorage.getItem('evora_pop'); } catch (e) {}
    var days = +pop.getAttribute('data-days') || 7;
    var forced = pop.hasAttribute('data-design-mode');
    if (forced || !seen || Date.now() - seen > days * 864e5) {
      setTimeout(function () { pop.classList.add('is-open'); }, forced ? 0 : (+pop.getAttribute('data-delay') || 8) * 1000);
    }
    $$('[data-popup-close]', pop).forEach(function (b) { b.addEventListener('click', closePop); });
    if (pop.hasAttribute('data-posted')) pop.classList.add('is-open');
  }

  /* ---------- editor de temas ---------- */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
